"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_EffectOnHit_OnAttackEventHandlerScript = void 0;
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_EffectOnHit_OnAttackEventHandlerScript = class Effect_EffectOnHit_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack || !event.args.hit) {
            return;
        }
        const chanceRoll = (0, Random_1.random)(1, 100);
        if (chanceRoll <= handler.args.scriptArgs.chancePercent) {
            if (handler.args.scriptArgs.effect.harmful) {
                container.applyDebuff({
                    sequence,
                    attackerId: event.subject,
                    targetId: event.args.targetId,
                    effect: handler.args.scriptArgs.effect,
                    duration: handler.args.scriptArgs.effectDuration
                });
            }
            else {
                container.applyBuff({
                    sequence,
                    creatorId: event.subject,
                    targetId: event.args.targetId,
                    effect: handler.args.scriptArgs.effect,
                    duration: handler.args.scriptArgs.effectDuration
                });
            }
        }
    }
};
Effect_EffectOnHit_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_EffectOnHit_OnAttack")
], Effect_EffectOnHit_OnAttackEventHandlerScript);
exports.Effect_EffectOnHit_OnAttackEventHandlerScript = Effect_EffectOnHit_OnAttackEventHandlerScript;
